// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cqoAM","icon":"styles_icon__-fHPN"};